import { render, staticRenderFns } from "./compare_driver_profiles.vue?vue&type=template&id=05f3a720&"
import script from "./compare_driver_profiles.vue?vue&type=script&lang=js&"
export * from "./compare_driver_profiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports